export default {
  name: "GovernanceLockSection",

  data() {
    return ({
      governance_data: {
        kicker: "Institutional-Grade Oversight",
        title: "The Governance Lock",
        description:
          "Your capital is protected by multiple layers of institutional safeguards, independent oversight, and asset security protocols.",
      },

      governance_cards: [
        {
          key: "independent_oversight",
          icon: "oversight",
          title: "Independent Oversight",
          description:
            "Governance committee includes mandated seats for independent legal counsel and top-tier audit firm representatives.",
        },
        {
          key: "ring_fencing",
          icon: "lock",
          title: "Ring-Fencing",
          description:
            "Capital is released only against verified milestones. Funds are strictly separated from operational accounts.",
        },
        {
          key: "asset_security",
          icon: "shield",
          title: "Asset Security",
          description:
            "The Fund retains ownership of physical assets as collateral. If a breach occurs, assets are recalled and redeployed within 30 days.",
        },
      ],
    });
  },
};